// index.js
import Home from './Home';

export default Home;



// WEBPACK FOOTER //
// ./src/comps/Home/index.js